/** @jsx jsx */
import { jsx, css, Global } from "@emotion/react";

import * as ZillaSlab from "../../fonts/Zilla_Slab/fontFaces.css";
import * as OpenSans from "../../fonts/Open_Sans/fontFaces.css";
import * as NotoSansSc from "../../fonts/Noto_Sans_SC/fontFaces.css";
import * as LearningCurve from "../../fonts/Learning_Curve/fontFaces.css";
import * as normalize from "./normalize.css";
import * as global from "./global.css";

import Auth from "../Auth";

const globalStyles = css`
  ${ZillaSlab}
  ${OpenSans}
  ${NotoSansSc}
  ${LearningCurve}
  ${normalize}
  ${global}
`;

export type AppProps = {
  children: React.ReactNode;
  location: {
    pathname: string;
    hash: string;
  };
};

export const App = (props: AppProps): React.ReactElement => {
  const { children, location } = props;

  return (
    <Auth location={location}>
      <Global styles={globalStyles} />
      {children}
    </Auth>
  );
};

export default App;
